<ng-container *transloco="let _t">

<header class="row">
	<div class="col-1 text-end" id="header-logo"><a [routerLink]="'/'">
		<img src="./miiar/assets/img/LOGO_MIIAR_SIMPLE_128_BLC.png" alt="MIIAR" class="vcenter" />
	</a></div>

	<div id="header-main-col" class="col-9 row">
		<h2 *ngIf="gd.headerTitle==null else hasTitle">
			<br>
			<small>{{ _t('header-hello') }}
				<em *ngIf="userIsConnected">{{user.name}}</em>
				{{ _t('header-welcome') }} </small><br>
			<strong>{{ _t('header-software') }}</strong>
		</h2>
		<ng-template #hasTitle>
		<h2 class="col-12" [ngClass]="{'smaller': gd.headerTitle.length>40 }">
			<mat-icon>{{gd.headerIcon}}</mat-icon> {{gd.headerTitle}}
		</h2>

		<div class="col-2 picture" *ngIf="building!=null">
			<cmat-picture
				[src]="building.photo" [alt]="Image"
				[zoomed]="true" [uploadable]="false">
			</cmat-picture>
		</div>
		<div id="header-building" class="col-9 row" *ngIf="building!=null">
			<h5 class="col-12">
				<strong>{{building.name}}</strong> &nbsp;
				<small>( {{ building.BuildingType.name}} )</small>
      </h5>

			<address class="col-4">
				{{building.adress1}}<br/>
				<span *ngIf="building.adress2!=null"> - {{building.adress2}}</span><br>
				{{building.zipcode}} {{building.town}} <br>
				{{building.region}} - {{building.country}}
			</address>
			<div class="col-4">
				<h5>{{ _t('main-header-h5-0') }}</h5><br>
				<p>{{building.User.name}} <br>
				<a [href]="'mailto:'+building.User.email">{{building.User.email}}</a><br>
				{{building.User.phone}}</p>
			</div>

			<div class="col-4" *ngIf="building.director!=undefinded">
				<h5>{{ _t('main-header-h5-1') }}</h5>
				<p>{{building.director}} <br>
				<a [href]="'mailto:'+building.email">{{building.email}}</a><br>
				{{building.phone}}</p>
			</div>
		</div>
		</ng-template>
	</div>

	<div id="header-account" class="col-2 text-center">
		<mat-form-field class="lang">
			<mat-select matInput name="lang" [(ngModel)]="lang">
				<mat-option [value]="'fr'">Français</mat-option>
				<mat-option [value]="'en'">English</mat-option>
			</mat-select>
		</mat-form-field>
		<br>
		<span *ngIf="userIsConnected">{{user.name}}</span><br>
		<button mat-mini-fab color="disabled"  *ngIf="userIsConnected"
			(click)="exit()" [title]="_t('exit')">
			<mat-icon>logout</mat-icon>
		</button>
	</div>

</header>

</ng-container>
